import { Search } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface EnrichDataNodeData {
  label: string;
  action?: string;
  outputVariable?: string;
}

export const EnrichDataNode = ({
  data,
  selected,
}: {
  data: EnrichDataNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="enrich_data"
    icon={<Search size={16} />}
    label={data.label}
    subtitle={
      data.action
        ? `${data.action}${data.outputVariable ? ` → ${data.outputVariable}` : ''}`
        : undefined
    }
    selected={selected}
    sources={
      data.action === 'extract_webpage'
        ? [
            {
              id: 'success',
              top: '32%',
              label: 'success',
              handleClass: '!bg-green-500',
              labelClass: 'text-green-600',
            },
            {
              id: 'failed',
              top: '68%',
              label: 'failed',
              handleClass: '!bg-red-500',
              labelClass: 'text-red-600',
            },
          ]
        : undefined
    }
  />
);
